<template>
  <el-dialog
    :title="testDia.title"
    :visible.sync="testDia.show"
    v-if="testDia.show"
    :close-on-click-modal="false"
  >
    <TestTable :data="testData" />
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" @click.native="closeFrom()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import TestTable from "./testTable.js";

export default {
  components: { butn, TestTable },
  props: ["testDia", "testData"],
  methods: {
    closeFrom() {
      this.$emit("closeDia", "testDia");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
